import { Constant } from "src/app/constants/constant";
import { EcryptServiceService } from "src/app/services/ecrypt-service.service";

export const environment = {
  production: true,
  serverAPI: 'https://www.halafresh.co.in/ecom-gateway/ecom-svc-catalog-1.0-SNAPSHOT',
  serverAPI2: 'https://www.halafresh.co.in/ecom-gateway/ecom-svc-core-1.0-SNAPSHOT',
  serverAPI3: 'https://www.halafresh.co.in/ecom-gateway/ecom-svc-sales-1.0-SNAPSHOT',
  serverAPI4: 'https://www.halafresh.co.in/ecom-gateway/ecom-svc-admin-1.0-SNAPSHOT',
  serverAPI6: 'https://www.halafresh.co.in/ecom-gateway/ecom-svc-partner-1.0-SNAPSHOT',
  serverAPI7: 'https://www.halafresh.co.in/ecom-gateway/ecom-svc-deploy-1.0-SNAPSHOT',
  ImageAPI: 'https://www.halafresh.co.in/ecom-gateway/ecom-svc-core-1.0-SNAPSHOT/api/core/download?fileName=catalog/product/small_image/200x170/',
  ImageAPI1: 'https://www.halafresh.co.in/ecom-gateway/ecom-svc-core-1.0-SNAPSHOT/api/core/download?fileName=catalog/product/image/600x600/',
  ImagePartnerAPI: 'https://www.halafresh.co.in/ecom-gateway/ecom-svc-core-1.0-SNAPSHOT/api/core/download/partner?fileName=',
  commonImageApi: 'https://www.halafresh.co.in/ecom-gateway/ecom-svc-core-1.0-SNAPSHOT/api/core/download?fileName=',
  youtubeUrl: 'https://www.youtube.com/embed/',
  thumnail: 'https://www.halafresh.co.in/ecom-gateway/ecom-svc-core-1.0-SNAPSHOT/api/core/download?fileName=catalog/product/thumbnail/75x75/',
  commonImageApiNew: 'https://www.halafresh.co.in/ecom-gateway/ecom-svc-core-1.0-SNAPSHOT/api/core/download/common?fileName=',
  HostUrl: 'https://www.halafresh.co.in',
  videoSocketUrl: 'https://www.halafresh.co.in/ecom-gateway1/api',
  firebase: getConfig(),
};
function getConfig() {
  let config;

  let finalData = localStorage.getItem(Constant.ENCRYPT_KEY_CONFIG_NEW);

  if (finalData == undefined) {
    finalData = localStorage.getItem(Constant.ENCRYPT_KEY_CONFIG);

  }

  let encryptService = new EcryptServiceService();
  let obj = null;
  if (finalData != null) {

    try {
      obj = JSON.parse(encryptService.decryptionAES(finalData));
    } catch (error) {
      obj = null;
    }
  }
  if (obj != null) {

    const config: any = {};

    if (obj['apiKey'] !== undefined) config.apiKey = obj['apiKey'];
    if (obj['authDomain'] !== undefined) config.authDomain = obj['authDomain'];
    if (obj['projectId'] !== undefined) config.projectId = obj['projectId'];
    if (obj['storageBucket'] !== undefined) config.storageBucket = obj['storageBucket'];
    if (obj['messagingSenderId'] !== undefined) config.messagingSenderId = obj['messagingSenderId'];
    if (obj['appId'] !== undefined) config.appId = obj['appId'];

  } else {


    let request = new XMLHttpRequest();
    try {


      var url = "https://" + Constant.REFERER + '/ecom-gateway/ecom-svc-catalog-1.0-SNAPSHOT/api/catalog/siteData/new'
      //var url = 'http://localhost:8086/ecom-gateway/ecom-svc-catalog-1.0-SNAPSHOT' + "/api/catalog/siteData"

      request.open('GET', url, false);  // `false` makes the request synchronous
      request.setRequestHeader('Content-Type', 'application/json');

      request.setRequestHeader(Constant.DEVICE, Constant.DEVICE_TYPE);

      request.setRequestHeader(Constant.ENTERPRISE_SITE, Constant.REFERER);


      request.send(null);

      // console.log(request);

      if (request.status === 200) {

        config = request.responseText;

        console.log("request", request);

        console.log("responseText", request.responseText);

        obj = JSON.parse(request.responseText);

        if (obj?.encryptedText != null) {
          localStorage.setItem(Constant.ENCRYPT_KEY_CONFIG_NEW, obj.encryptedText);
          let decrypted = encryptService.decryptionAES(obj.encryptedText);
          obj = JSON.parse(decrypted);
        } else {

          let valueNew = encryptService.encryptionAES(JSON.stringify(obj));

          localStorage.setItem(Constant.ENCRYPT_KEY_CONFIG, valueNew);

        }


        config = {
          apiKey: obj['apiKey'],
          authDomain: obj['authDomain'],
          projectId: obj['projectId'],
          storageBucket: obj['storageBucket'],
          messagingSenderId: obj['messagingSenderId'],
          appId: obj['appId']
        };
      }

    } catch (e) {
      console.error('environment:getConfig: unable to get api key : ', e);
    }

  }


  return config;
}
